export default __webpack_public_path__ + "static/media/ideation.022d2822.svg";